// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"InsomniaRewardsTerms_pageWrapper__zAMuH","pageContainer":"InsomniaRewardsTerms_pageContainer__37Bp-","pageSection":"InsomniaRewardsTerms_pageSection__2-Zmw"};